import { render, staticRenderFns } from "./freeShow.vue?vue&type=template&id=a06f0acc&"
import script from "./freeShow.vue?vue&type=script&lang=js&"
export * from "./freeShow.vue?vue&type=script&lang=js&"
import style0 from "./freeShow.vue?vue&type=style&index=0&id=a06f0acc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports